import { render, staticRenderFns } from "./Banco.vue?vue&type=template&id=2996c4f4"
import script from "./Banco.vue?vue&type=script&lang=js"
export * from "./Banco.vue?vue&type=script&lang=js"
import style0 from "./Banco.vue?vue&type=style&index=0&id=2996c4f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports